<template>
    <label v-if="visible" class="skin-select">
        <span>{{ $t('displayUi.appearance') }}</span>
        <select :value="$store.getters.themeSkin" :aria-label="$t('displayUi.appearance')" @change="$setThemeSkin($event.target.value)">
            <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
        </select>
    </label>
</template>
<script>
import { themes } from '@/themes'
import { themeLabel } from '@/themes/labels'
import { showThemeSkinSelect } from '@/common/http'
export default {
    name: 'ThemeSkinSelect',
    computed: {
        visible() { return showThemeSkinSelect && Object.keys(themes).length > 1 },
        options() { return Object.keys(themes).map(value => ({ value, label: themeLabel(value, this.$i18n.locale) })) }
    }
}
</script>
<style scoped>
.skin-select { display: flex; align-items: center; gap: 8px; padding: 10px; border: 1px solid var(--theme-surface-border); border-radius: 8px; background: var(--theme-input-bg); color: var(--theme-soft-text); font: 12px/1.5 'Segoe UI', Arial, sans-serif; }
.skin-select > span { flex: 0 1 auto; }
.skin-select select { flex: 1; width: 0; min-width: 0; min-height: 34px; padding: 4px; border: 0; background: var(--theme-input-bg); color: var(--theme-bright-text); font: inherit; cursor: pointer; }
.skin-select select:focus-visible { outline: 2px solid var(--theme-input-focus-border); outline-offset: 2px; }
</style>
